import React from "react";

const Oneliner = () => {
  return (
    <section className="oneliner-container" aria-labelledby="oneliner-section">
      <h3 id="oneliner">
        Voor het verminderen van rimpels en het verstrakken & egaliseren van de
        huid. <span>Laat zien hoe mooi je bent.</span>
      </h3>
    </section>
  );
};

export default Oneliner;
